import * as React from 'react'
import './loader.css'

export const Loader = {
    PopupLoader: ({ show, className }) =>
        show && <div id="popuploader" className={className} />,
    PageLoader: ({ show, loadingText, extraMsg }) =>
        show && (
            <div className="loader">
                <div className="loader-child">
                    <div>
                        <div id="preloader">
                            <span />
                            <p className="preloader_p1">{loadingText}</p>
                            {extraMsg && <p>{extraMsg}</p>}
                        </div>
                    </div>
                </div>
            </div>
        ),
    ErrorPage: ({ show }) => show && <div id="oops_loader" />,
}
